/**
 * The component and its path→items helper now live in `@gjl/studio-chrome`, so
 * the hymnal's breadcrumbs are the same ones and cannot drift. Re-exported from
 * the original path because 38 modules import it from here.
 *
 * `breadcrumbLabels` stays: it is a map of studio's own routes, and the hymnal
 * passes its own labels to the same `generateBreadcrumbs`.
 */
export { Breadcrumbs } from '@gjl/studio-chrome'
export type { BreadcrumbItem } from '@gjl/studio-chrome'
// eslint-disable-next-line react-refresh/only-export-components -- helper re-exported alongside the component it belongs to; 38 importers, splitting would churn; dev-only Fast Refresh hint
export { generateBreadcrumbs } from '@gjl/studio-chrome'

/**
 * Common breadcrumb label mappings for the site
 */
// eslint-disable-next-line react-refresh/only-export-components -- label map co-located with Breadcrumbs; dev-only Fast Refresh hint
export const breadcrumbLabels: Record<string, string> = {
  '/services': 'Services',
  '/services/done-for-you': 'Done For You',
  '/music-manager': 'Music Library & Rehearsal Manager',
  '/services/email-marketing': 'Email Marketing',
  '/services/donor-management': 'Donor Management',
  '/services/ticketing': 'Ticketing',
  '/services/applications': 'Applications & Auditions',
  '/services/design': 'Graphic Design',
  '/services/photography': 'Photography',
  '/portfolio': 'Portfolio',
  '/blog': 'Blog',
  '/platform': 'Fugue Lab App',
  '/platform/features': 'Features',
  '/resources': 'Resources',
  '/resources/grants': 'Grant Funding',
  '/pricing': 'Packages',
  '/about': 'About',
  '/contact': 'Contact',
  '/get-started': 'Get Started',
  '/book': 'Book a Discovery Call',
  '/checklist': 'Website Checklist',
  '/requests': 'Request an Update',
  '/who-we-help': 'Who We Help',
  '/compare': 'Compare',
  '/integrations': 'Integrations',
  '/integrations/email-delivery': 'Email delivery',
  '/integrations/stripe': 'Stripe',
  '/integrations/google-calendar': 'Google Calendar',
  // Who we serve segments
  'music-festivals': 'Music Festivals',
  'choral-festivals': 'Choral Festivals & Choruses',
  'young-artist-programs': 'Young Artist & Conducting Programs',
  'pre-college-summer-programs': 'Pre-College & Summer Programs',
  'churches-sacred-music': 'Churches & Sacred Music',
  'music-schools': 'Music Schools & Studios',
  // Compare pages
  acceptd: 'vs Acceptd',
  squarespace: 'vs Squarespace',
  wix: 'vs Wix',
  wordpress: 'vs WordPress',
  // Service pages
  websites: 'Websites',
  'festival-websites': 'Festival Websites',
  'festival-retainer': 'Festival Retainer',
  'digital-systems': 'Digital Systems',
  'application-funnels': 'Applications',
  'digital-partnership': 'Digital Partnership',
  // Platform features
  donations: 'Donor Management',
  website: 'Website',
  events: 'Ticketing',
  email: 'Email',
  team: 'Team',
  analytics: 'Analytics',
  // Blog
  'chroma-festival-case-study': 'Chroma Festival Case Study',
  'festivals-losing-applicants': 'Why Festivals Are Losing Applicants',
  'best-website-platforms-for-music-festivals': 'Best Website Platforms for Music Festivals',
  'great-host-composers-case-study': 'A Great Host of Composers Case Study',
}
